export default __webpack_public_path__ + "static/media/tel-icon-blue.d5bf40dd.svg";